// Mantiene il markup nativo dei wallet. Su mobile viene attivato avvicinandosi
// all'acquisto; nel drawer soltanto quando il carrello viene aperto.
class DeferredPayment extends HTMLElement {
  connectedCallback() {
    // Il carrello puo essere aggiornato via morph mantenendo questo elemento.
    // Un nuovo template deve attivarsi anche senza un nuovo connectedCallback.
    this.contentObserver = new MutationObserver(() => this.prepare());
    this.contentObserver.observe(this, { childList: true });
    this.prepare();
  }

  prepare() {
    if (!this.querySelector(':scope > template')) return;
    this.stopWaiting();
    const dialog = this.closest('dialog');
    if (dialog) {
      if (dialog.open) return this.activate();
      this.dialogObserver = new MutationObserver(() => {
        if (dialog.open) this.activate();
      });
      this.dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    } else if (matchMedia('(min-width: 750px)').matches || !('IntersectionObserver' in window)) {
      this.activate();
    } else {
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, { rootMargin: '64px 0px' });
      this.visibilityObserver.observe(this);
    }
  }

  activate() {
    const template = this.querySelector(':scope > template');
    if (!template) return;
    this.stopWaiting();
    template.replaceWith(template.content);
    this.dataset.active = 'true';
    // Stesso punto di inizializzazione usato dal quick-add ufficiale Shopify Dawn.
    window.Shopify?.PaymentButton?.init?.();
  }

  stopWaiting() {
    this.visibilityObserver?.disconnect();
    this.dialogObserver?.disconnect();
  }

  disconnectedCallback() {
    this.stopWaiting();
    this.contentObserver?.disconnect();
  }
}
if (!customElements.get('kg-deferred-payment')) customElements.define('kg-deferred-payment', DeferredPayment);
